import { render, staticRenderFns } from "./ChangePaymentType.vue?vue&type=template&id=1f8ba8e2"
import script from "./ChangePaymentType.vue?vue&type=script&lang=js"
export * from "./ChangePaymentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports